<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main" dir="ltr">
    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p class="m-0 font-4">{{ details.title }}</p>
      <div onclick="window.history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

      <div class="p-body">
        <div class="div_img_products rounded-4 my-3">

          <img v-if="details.pics.length === 0" class="div_img_products rounded-4" src="../assets/img/img-notavalible.jpg"
               alt="">

          <v-carousel v-else
                      class="div_img_products rounded-4 "
                      :show-arrows="false"
                      hide-delimiter-background>
            <v-carousel-item
                v-for="pic in details.pics"
                :key="pic.index"
                class="img_products "
                :src="pic"

            ></v-carousel-item>
          </v-carousel>
        </div>

        <div class=" mb-2">
          <div class="d-flex justify-content-around p-3 bg-white rounded-4 border-costom align-items-center">
            <div class="d-flex align-items-center">
              <p class="m-0 font-4 me-2">{{ details.date }}</p>

              <img style="width: 2rem;height: 2rem" class="" src="../assets/img/icon_calendar_.svg" alt="">
            </div>

            <div class="d-flex align-items-center">
              <p class="m-0 font-4 me-2">{{ details.source }}</p>

              <img style="width: 2rem;height: 2rem" class="" src="../assets/img/blog-_1_.svg" alt="">
            </div>
          </div>
        </div>

        <div class=" mb-2">
          <div class="p-3 bg-white rounded-4 border-costom">
            <div class="w-100" dir="rtl">
              <p v-html="details.content" class="font-4 w-100 m-0"></p>
            </div>
          </div>
        </div>
      </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div dir="rtl" style="background-color: white" class="rounded-4 font-bold font-color p-3 my-4 w-75 ma-auto">{{details.title }}</div>

    <div dir="rtl" class="rounded-4 m-auto w-75 font-4">

      <div class="div_img_products bg-white p-4 rounded-4 mb-3">

        <img v-if="details.pics.length === 0" class="div_img_products rounded-4" src="../assets/img/img-notavalible.jpg"
             alt="">

        <v-carousel v-else
                    class="h-100 w-100 rounded-4 "
                    :show-arrows="false"
                    hide-delimiter-background>
          <v-carousel-item
              v-for="pic in details.pics"
              :key="pic.index"
              class="img_products "
              :src="pic"
          ></v-carousel-item>
        </v-carousel>
      </div>

      <div class=" mb-2">
        <div class="d-flex justify-content-around p-3 bg-white rounded-4 border-costom align-items-center">
          <div class="d-flex align-items-center">
            <p class="m-0 font-5 ms-2">{{ details.date }}</p>

            <img style="width: 1.5rem;height: 1.5rem" class="" src="../assets/img/icon_calendar_.svg" alt="">
          </div>

          <div class="d-flex align-items-center">
            <p class="m-0 font-5 ms-2">{{ details.source }}</p>

            <img style="width: 1.5rem;height: 1.5rem" class="" src="../assets/img/blog-_1_.svg" alt="">
          </div>
        </div>
      </div>

      <div class=" mb-2">
        <div class="p-3 bg-white rounded-4 border-costom">
          <div class="w-100" dir="rtl">
            <p v-html="details.content" class="font-5 w-100 m-0"></p>
          </div>
        </div>
      </div>

    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";

export default {
  name: 'DetailsProducts',
  components: {LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)
    let bid = useRoute().params.bid
    let details = ref({
      pics: [],
      title: '',
      content: '',
      date: '',
      source: '',
    })

    function get_blog() {
      loading.value = true

      FreeWorld.Heisenberg({id:bid , action:'blog'},'Element').then((res)=>{

        loading.value = false
        details.value = res.data

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , get_blog)
      })
    }
    get_blog()

    return {
      loading,
      details,
    }
  }
}
</script>

<style scoped>

@media (min-width: 850px) {
  .div_img_products {
    width: 95%;
    margin: 0 auto;
    height: 44rem !important;
  }
}

@media (min-width: 500px) and (max-width: 850px) {
  .div_img_products {
    width: 96%;
    margin: 0 auto;
    height: 33.5rem !important;
  }
}

@media (min-width: 0) and (max-width: 500px){
  .div_img_products {
    width: 96%;
    margin: 0 auto;
    height: 28rem !important;
  }
}

.img_products {
  width: 100% !important;
  height: 100% !important;
}
</style>
